export default "__VITE_ASSET__jb9VndFm__"